import React from "react";
import { useTranslation } from "react-i18next";

import logoSmall from "/asset/image/logo-white.svg";
import { useSignUpProvider } from "/component/provider/SignUpProvider";
import { SignUpFormType } from "/constant/signUp.constant";

import AccountCreatedTutorial from "./AccountCreatedTutorial";
import CreateAccountTutorial from "./CreateAccountTutorial";
import { LogoContainer } from "./GeneralTutorials.styles";
import { GeneralTutorialsContainer } from "./GeneralTutorials.styles";
import VerifyPhoneTutorial from "./VerifyPhoneTutorial";

const TUTORIAL_MAP: Partial<Record<SignUpFormType, React.ComponentType>> = {
  [SignUpFormType.AccountCreated]: AccountCreatedTutorial,
  [SignUpFormType.PhoneVerification]: VerifyPhoneTutorial,
};

const GeneralTutorials = () => {
  const { currentForm } = useSignUpProvider();
  const { t } = useTranslation("screen-generalTutorials");
  const CurrentTutorial = TUTORIAL_MAP[currentForm];

  return (
    <GeneralTutorialsContainer>
      <LogoContainer>
        <img height={41} alt={t("logo")} src={logoSmall} />
      </LogoContainer>
      {CurrentTutorial ? <CurrentTutorial /> : <CreateAccountTutorial />}
    </GeneralTutorialsContainer>
  );
};

export default GeneralTutorials;
